module.exports = {
    cavaliers: () => {
        $('form.js-cavaliers-form').on('submit', function (e) {
            e.preventDefault();

            const form = $(this);
            const url = form.attr('action');
            const button = form.find('.js-btn-save-cavaliers');
            const $modal = form.closest('.modal');
            const $categorySpecial = $('.category-special');
            const $categoryProducts = $('.category__products');

            $('.js-general-error').hide();
            $('.js-general-error').empty();

            button.attr('disabled', true);
            $.spinner().start();

            const errorMsg = 'For technical reasons, your request could not be handled properly at this time. We apologize for any inconvenience';

            $.ajax({
                url,
                type: 'POST',
                dataType: 'json',
                data: form.serialize(),
                success: (data) => {
                    button.removeAttr('disabled');
                    $.spinner().stop();
                    if (data.success) {
                        $modal.modal('hide');
                        $categoryProducts.hide();
                        $categorySpecial.addClass('confirmation');
                    } else {
                        $('.js-general-error').html(data.message);
                        $('.js-general-error').show();
                    }
                },
                error: () => {
                    button.removeAttr('disabled');
                    $.spinner().stop();
                    $('.js-general-error').show().text(errorMsg);
                },
            });
            return false;
        });
    },
};
